import { CONNECTION_STORAGE_KEYS } from '../stores/connectionStore';
import { FACILITY_STORAGE_KEY } from '../stores/globalStore';
import { AUTO_CONNECT_KEY } from './singleOrgAutoConnect';

/**
 * Forgets what this tab picked for the signed-in user: the connection, who picked it, and the
 * facility. Log Out used to leave all three in sessionStorage, so the next person to sign in on
 * the same tab (a shared kitchen iPad) started in the previous user's database and facility.
 * Also forgets that the one-organization automatic connect was used, so the next sign-in gets it.
 */
export function clearSignedInSession(): void {
  for (const key of [...CONNECTION_STORAGE_KEYS, FACILITY_STORAGE_KEY, AUTO_CONNECT_KEY]) {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // Storage unavailable: nothing was saved there either.
    }
  }
}

/** Log Out: clear the tab's saved session first, then end the Keycloak sign-in. */
export function signOut(auth: { signoutRedirect: () => Promise<void> | void }): void {
  clearSignedInSession();
  void auth.signoutRedirect();
}
